import React, { Component } from 'react';
import {Grid, Row, Col} from 'react-bootstrap';
class WhoWeAre extends Component {
  render() {
    return (
          <div className="correction">
            <div className='container-fluid whoWeAreMain'>
              <Grid >
                <Row>
                  <Col xsHidden  md={12}>
                    <div className="timeLine2">
                        <div className="infoSide">
                          <h1>Beratung, Service und Lösungsfindung</h1>
                          <br/>
                          <h4>Die Firma Mauersberger ist seit mehreren Jahrezehnten eine klassische Industrievertretung, mit dem Schwerpunkt Metallverarbeitung und Werkzeug-/Formenbau.</h4>
                          <br/>
                          <h4>Durch den engen Kontakt zu unseren Kunden und Partnerfirmen, optimieren wir laufend unsere Produkte und bringen Kundenwünsche bei Neuentwicklungen ein.</h4>
                          <br/>
                          <h4>Mit und für unsere Kunden entwickeln wir individuelle Lösungskonzepte zur Arbeitsplatzgestaltung, Modernisierung und Rationalisierung der täglichen Arbeitsabläufe.</h4>
                          <br/>
                          <h4>Als Dienstleister bieten wir unseren Kunden und deren Mitarbeiten Produktschulungen und Beratungsgespräche an.</h4>

                        </div>
                      </div>
                  </Col>

                  <Col   xs={12} smHidden mdHidden lgHidden>
                    <div className="timeLine2_xs">
                        <div className="infoSide">
                          <h1>Beratung, Service und Lösungsfindung</h1>
                          <br/>
                          <h4>Die Firma Mauersberger ist seit mehreren Jahrezehnten eine klassische Industrievertretung, mit dem Schwerpunkt Metallverarbeitung und Werkzeug-/Formenbau.</h4>
                          <br/>
                          <h4>Durch den engen Kontakt zu unseren Kunden und Partnerfirmen, optimieren wir laufend unsere Produkte und bringen Kundenwünsche bei Neuentwicklungen ein.</h4>
                          <br/>
                          <h4>Mit und für unsere Kunden entwickeln wir individuelle Lösungskonzepte zur Arbeitsplatzgestaltung, Modernisierung und Rationalisierung der täglichen Arbeitsabläufe.</h4>
                          <br/>
                          <h4>Als Dienstleister bieten wir unseren Kunden und deren Mitarbeiten Produktschulungen und Beratungsgespräche an.</h4>

                        </div>
                      </div>
                  </Col>
                </Row>
              </Grid>
            </div>
          </div>
    );
  }
}

export default WhoWeAre;



// WEBPACK FOOTER //
// ./src/components/pages/whoWeAre.js